module.exports = __webpack_public_path__ + "static/media/cq_ordine_tempo1.d9f1f5aa.svg";